<template lang="pug">
aside.main-menu.web-menu-background-color.web-app-menu(v-if="shouldShowWebMenu")
  .d-flex.flex-column.menu-inner
    router-link(to='/web/').menu-logo-link.d-flex.padding-left-35
      img(src="@/assets/images/logos/bolt-white.svg").w-60

    router-link.menu-promo-text(
      to="/web/org/sandiegogives"
      :class="{ 'is-active': isMenuActive('/web/org/sandiegogives') }"
    ) San Diego Gives 2026

    acting-entity-switcher(v-if="isSignedIn" :profile="profileState.profile")

    #nav.flex-grow-1.d-flex.flex-column.pos-r.main-menu-items(
      ref="navRef"
      @scroll.passive="saveNavScroll"
    )

      h5.mb-3(v-if="backTo")
        .padding-left-60 {{ backBtnLabel }}
        fai(type="fal" icon="arrow-left" @click="goBack").back-arrow

      el-menu(
        :default-active="activeMenuItem"
        :collapse="false"
        background-color="transparent"
        active-text-color="#111"
        :unique-opened="true"
        @select="handleSelectMenu"
      )
        slot

        el-menu-item(
          index="/web/dashboard"
          :class="isMenuActive('/web/dashboard')"
          v-if="isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="shopping-bag").menu-icon
            span Marketplace

        el-menu-item(
          index="/web/checkout"
          :class="isMenuActive('/web/checkout')"
          v-if="isSignedIn"
        )
          .menu-item-content
            .icon-with-badge
              fai(type="fal" icon="shopping-cart").menu-icon
              .cart-badge(v-if="cartItemCount > 0") {{ cartItemCount }}
            span Cart

        el-menu-item(
          index="/web/stickers/purchased"
          :class="isMenuActive('/web/stickers/purchased')"
          v-if="isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="history").menu-icon
            span Purchase History

        el-menu-item(
          index="/web/ticket-orders"
          :class="isMenuActive('/web/ticket-orders')"
          v-if="isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="ticket").menu-icon
            span My Tickets

        el-menu-item(
          :index="userProfilePath"
          :class="isMenuActive(userProfilePath)"
          v-if="isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="user").menu-icon
            span My Profile

        el-menu-item(
          index="/web/glows"
          :class="isMenuActive('/web/glows')"
          v-if="isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="star").menu-icon
            span Glows

        el-menu-item(
          index="/web/favorites"
          :class="isMenuActive('/web/favorites')"
          v-if="isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="heart").menu-icon
            span Saved Events

        el-menu-item(
          index="/web/wallet/dashboard"
          :class="isMenuActive('/web/wallet/dashboard')"
          v-if="isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="wallet").menu-icon
            span Giving Wallet

        el-menu-item(
          index="/web/activity"
          :class="isMenuActive('/web/activity')"
          v-if="isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="bell").menu-icon
            span Activity

        el-menu-item(
          :index="`/web/profile/organization`"
          :class="isMenuActive(`/web/profile/organization`)"
          v-if="isSignedIn && hasOrganizations && !isActingAsOrganization"
        )
          .menu-item-content
            fai(type="fal" icon="building").menu-icon
            span Organization Profile

        el-menu-item(
          @click="launchCms"
          index="#launch-cms"
          class="external-link"
          v-if="isSignedIn && cmsLaunch.hasOrganizations && cmsLaunch.cmsUrl"
        )
          .menu-item-content
            fai(type="fal" icon="external-link-alt").menu-icon
            span Launch CMS on desktop

        el-menu-item(
          index="/web/page/make-a-donation"
          :class="isMenuActive('/web/page/make-a-donation')"
          v-if="isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="dollar-sign").menu-icon
            span Make a Donation

        el-menu-item(
          index="/web/dashboard"
          :class="isMenuActive('/web/dashboard')"
          v-if="!isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="shopping-bag").menu-icon
            span Marketplace
        el-menu-item(
          index="/web/checkout"
          :class="isMenuActive('/web/checkout')"
          v-if="!isSignedIn"
        )
          .menu-item-content
            .icon-with-badge
              fai(type="fal" icon="shopping-cart").menu-icon
              .cart-badge(v-if="cartItemCount > 0") {{ cartItemCount }}
            span Cart
        el-menu-item(
          index="/web/glows"
          :class="isMenuActive('/web/glows')"
          v-if="!isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="star").menu-icon
            span Glows
        el-menu-item(
          index="/web/page/make-a-donation"
          :class="isMenuActive('/web/page/make-a-donation')"
          v-if="!isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="dollar-sign").menu-icon
            span Make a Donation
        el-menu-item(
          index="/auth/web/signup"
          v-if="!isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="user-plus").menu-icon
            span Get Started
        el-menu-item(
          index="/auth/web/signin"
          v-if="!isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="right-to-bracket").menu-icon
            span Login
        el-menu-item(
          index="/web/settings"
          :class="isMenuActive('/web/settings')"
          v-if="isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="gear").menu-icon
            span Settings
        el-menu-item(
          @click="openLegalPage"
          index="#legal"
          class="external-link"
        )
          .menu-item-content
            fai(type="fal" icon="file-text").menu-icon
            span Legal
        el-menu-item(
          @click="openHelp"
          index="#help"
          class="external-link"
        )
          .menu-item-content
            fai(type="fal" icon="circle-question").menu-icon
            span Help
        el-menu-item(
          @click="handleSignOut()"
          index="/auth/web/signin"
          v-if="isSignedIn"
        )
          .menu-item-content
            fai(type="fal" icon="right-from-bracket").menu-icon
            span Logout
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  reactive,
  onMounted,
  watch,
  nextTick,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

import { dashboard as menuItems } from '@/data/main-menu';
import shared from '@/shared';
import gqlRequest from '@/views/web-app/dashboard/gql-request';
import { cmsLaunchInfo } from '@/graphs/gql';
import { actingProfilePath, useActingEntity } from '@/composables/useActingEntity';
import ActingEntitySwitcher from './ActingEntitySwitcher.vue';

const MENU_SCROLL_KEY = 'webMenuScrollTop';

export default defineComponent({
  name: 'WebAppMenu',
  components: { ActingEntitySwitcher },

  props: {
    items: { type: Array, default: menuItems },
    isWebAppMenu: { type: Boolean, default: false },
    backTo: { type: String, default: '' },
    backBtnLabel: { type: String, default: '' },
  },

  setup(props) {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const { fetchProfile, loadMyOrganizations } = gqlRequest();

    const profileState = reactive({
      profile: null as any,
      loading: false,
    });

    const { organization: actingOrganization, isOrganization: isActingAsOrganization } = (
      useActingEntity()
    );

    // "My Profile" is the profile of whoever the user is acting as, like mobile's profile tab
    const userProfilePath = computed(() => (
      actingProfilePath(actingOrganization.value, store.getters['users/me'])
    ));

    const cartItemCount = computed(() => store.getters['cart/lineCount'] || 0);

    // Every page mounts its own menu: keep the items' scroll position for this tab, so a short
    // window doesn't jump back to the top after each click
    const navRef = ref<HTMLElement | null>(null);
    const saveNavScroll = () => {
      try {
        sessionStorage.setItem(MENU_SCROLL_KEY, String(navRef.value?.scrollTop ?? 0));
      } catch {
        // storage unavailable: the menu starts at the top
      }
    };
    const restoreNavScroll = () => {
      const nav = navRef.value;
      if (!nav) return;
      try {
        nav.scrollTop = Number(sessionStorage.getItem(MENU_SCROLL_KEY)) || 0;
      } catch {
        // storage unavailable: the menu starts at the top
      }
      // A page opened from elsewhere (a link, a redirect): make sure its item is in view
      nav.querySelector('.el-menu-item.is-active')?.scrollIntoView({ block: 'nearest' });
    };

     
    const openLegalPage = function () {
      window.location.href = import.meta.env.VITE_LEGAL_PAGE_LINK;
    };

     
    const openHelp = function () {
      window.location.href = `mailto:${import.meta.env.VITE_EMAIL_SUPPORT}`;
    };
    const { isOrgAdmin, makeGraphRequest } = shared();
    // const { orgId } = route.params;
    const isSignedIn = store.getters['users/isMeSignedIn'];
    const shouldShowWebMenu = computed(() => route.path.startsWith('/web') || route.path.startsWith('/auth/web/complete-profile'));

    // Load profile data
    const loadProfile = async () => {
      if (!isSignedIn) return;

      try {
        profileState.loading = true;
        await loadMyOrganizations();
        profileState.profile = await fetchProfile();
      } catch (error) {
        console.error('Error loading profile:', error);
        profileState.profile = null;
      } finally {
        profileState.loading = false;
        // Items that depend on the profile (Organization Profile) change the menu's height
        nextTick(restoreNavScroll);
      }
    };

    /**
     * Computed property to check if user has valid organizations
     * Only considers organizations that are active, approved, onboarded, and not denied/withdrawn
     * Checks both profile organizations and store's selected organization
     */
    const hasOrganizations = computed(() => {
      const selectedOrg = store.getters['organizations/GET_SELECTED_ORGANIZATION'];
      const storedOrgIds = store.getters['organizations/GET_USER_MANAGED_ORGANIZATION_IDS'] ?? [];

      if (storedOrgIds.length > 0) {
        return true;
      }

      // Filter profile organizations to only include valid ones
      const validProfileOrgs = profileState.profile?.user?.organizations?.filter((org) => (
        org.approved && org.onboarded
      )) ?? profileState.profile?.organizations?.filter((org) => (
        org.active
        && org.approved
        && !org.denied
        && !org.withdrawn
        && org.onboarded
      ));
      const hasValidProfileOrgs = validProfileOrgs && validProfileOrgs.length > 0;

      // Only consider selectedOrg valid if it meets the same criteria
      const hasValidSelectedOrg = selectedOrg
        && selectedOrg.active
        && selectedOrg.approved
        && !selectedOrg.denied
        && !selectedOrg.withdrawn
        && selectedOrg.onboarded;

      return hasValidProfileOrgs || hasValidSelectedOrg;
    });

    const toShow = computed(() => props.items.map((p: any) => {
      // hide logout button if not logged in
      if (p.label === 'Logout' && !isSignedIn) {
        return false;
      }
      // hide login button if already logged in
      if (p.label === 'Login' && isSignedIn) {
        return false;
      }
      // hide Supported Causes if user has no organizations
      if (p.label === 'Supported Causes' && !hasOrganizations.value) {
        return false;
      }
      // if the current page does not have org id, hide the sticker sidebar menu
      if (p.path.indexOf('ORG_ID') >= 0 && !route.params.orgId) {
        return false;
      }
      return true;
    }));

    const isMenuActive = (vRoute: string): string => {
      if (route.path === vRoute) return 'is-active';
      return '';
    };

    const handleSelectMenu = (key: string): void => {
      // available perms: key, keyPath
      if (route.path === key) return;

      router.push(key);
    };

    const goBack = () => {
      router.go(-1);
    };

    const handleSignOut = (redirectSticker = false) => {
      store.dispatch('users/resetMe');
      const path = window.location.pathname;
      const pathSplit = path.split('/');
      // Signing out lands on sign-in (someone who just had an account), not on sign-up
      router.push(`/auth/web/signin${redirectSticker === true && path.startsWith('/web/sticker/') ? `?stickerId=${pathSplit[pathSplit.length - 1]}` : ''}`);
    };

    // Watch for changes in organization selection to ensure reactivity
    watch(
      () => store.getters['organizations/GET_SELECTED_ORGANIZATION'],
      () => {
        // Trigger reactivity for hasOrganizations computed property
      },
    );

    /**
     * Clean up stale organization data from store and localStorage
     * Removes organizations that are no longer valid (inactive, denied, withdrawn, etc.)
     */
    const cleanupStaleOrganizationData = () => {
      const selectedOrg = store.getters['organizations/GET_SELECTED_ORGANIZATION'];
      if (selectedOrg) {
        const isValid = selectedOrg.active
          && selectedOrg.approved
          && !selectedOrg.denied
          && !selectedOrg.withdrawn
          && selectedOrg.onboarded;

        if (!isValid) {
          store.dispatch('organizations/SET_SELECTED_ORGANIZATION', null);
          localStorage.removeItem('selectedOrganization');
        }
      }
    };

    const cmsLaunch = reactive({ hasOrganizations: false, cmsUrl: '' });
    const loadCmsLaunch = async () => {
      if (!isSignedIn) return;
      try {
        const response = await makeGraphRequest('query', cmsLaunchInfo, {});
        const info = response?.data?.cmsLaunchInfo;
        if (info) Object.assign(cmsLaunch, info);
      } catch (e) {
        // optional entry point: stay hidden on failure
      }
    };
    const launchCms = () => {
      if (cmsLaunch.cmsUrl) window.open(cmsLaunch.cmsUrl, '_blank', 'noopener');
    };

    // Load profile data when component mounts
    onMounted(() => {
      restoreNavScroll();
      loadProfile();
      loadCmsLaunch();
      // Clean up any stale organization data after a short delay to allow other components to load
      setTimeout(cleanupStaleOrganizationData, 500);
    });

    return {
      // data
      activeMenuItem: ref(null),
      isOrgAdmin,
      toShow,
      isSignedIn,
      userProfilePath,
      hasOrganizations,
      isActingAsOrganization,
      profileState,
      cmsLaunch,
      launchCms,
      cartItemCount,
      navRef,
      saveNavScroll,
      // methods
      isMenuActive,
      handleSelectMenu,
      handleSignOut,
      goBack,
      openLegalPage,
      openHelp,
      shouldShowWebMenu,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables';

// Menu Items Styling
:deep(.el-menu) {
  border-right: none;
}

:deep(.el-menu-item) {
  font-weight: 500;
  font-size: 15px !important;
  background-color: transparent !important;
  color: rgba(255, 255, 255, 0.85) !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
  margin: 4px 16px;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  height: 48px;
  line-height: 48px;
  position: relative;
  border-left: 3px solid transparent;

  &:hover {
    background-color: rgba(255, 255, 255, 0.08) !important;
    color: #ffffff !important;
    transform: translateX(2px);
  }

  &.is-active {
    background: linear-gradient(
      90deg,
      rgba(20, 184, 166, 0.25) 0%,
      rgba(20, 184, 166, 0.12) 100%
    ) !important;
    color: #ffffff !important;
    font-weight: 600;
    border-left-color: #14b8a6;
    box-shadow: 0 2px 8px rgba(20, 184, 166, 0.2);
  }
}

.menu-item-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.icon-with-badge {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.cart-badge {
  position: absolute;
  top: -6px;
  right: -8px;
  background: #ef4444;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.menu-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
}

:deep(.el-menu-item::after) {
  display: none !important;
}

:deep(.el-menu-item::before) {
  display: none !important;
}

:deep(.el-menu-item.is-active::before) {
  display: none !important;
}

.menu-inner {
  flex: 1;
  min-height: 0;
  height: 100%;
}

.main-menu-items {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  // Scrolling past the last item doesn't scroll the page behind the menu
  overscroll-behavior: contain;

  :deep(.el-menu) {
    height: auto !important;
    border-right: none;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    margin: 8px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;

    &:hover {
      background: rgba(255, 255, 255, 0.35);
    }
  }
}

// Main Menu Container
aside.main-menu {
  position: absolute;
  left: 0;
  top: 0;
  height: 100vh;
  height: 100dvh;
  width: $main-menu-width;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

@media (min-width: 1921px) {
  aside.main-menu {
    position: fixed;
    left: calc(50vw - 960px);
    top: 0;
    height: 100vh;
    // The visible height: phone browser toolbars don't cover the bottom items
    height: 100dvh;
    width: $main-menu-width;
    z-index: 1001;
  }
}

@media (max-width: 1920px) {
  aside.main-menu {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    // The visible height: phone browser toolbars don't cover the bottom items
    height: 100dvh;
    width: $main-menu-width;
    z-index: 1001;
  }
}

// Mobile: Menu slides in from left as overlay
@media (max-width: 1023px) {
  aside.main-menu {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    // The visible height: phone browser toolbars don't cover the bottom items
    height: 100dvh;
    width: $main-menu-width-responsive;
    z-index: 1001;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
  }
  
  // Show menu when menu-open class is present
  .menu-open aside.main-menu {
    transform: translateX(0);
  }
}

// Logo & promo text link (temporary — San Diego Gives 2026)
.menu-logo-link {
  padding-top: 1.25rem;
  padding-bottom: 0.5rem;
}

.menu-promo-text {
  display: block;
  padding-left: 35px;
  padding-right: 1rem;
  margin-top: 1rem;
  margin-bottom: 1.25rem;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.35;
  letter-spacing: 0.01em;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.92);
  transition: color 0.2s ease;

  &:hover {
    color: #ffffff;
  }

  &.is-active {
    color: #5eead4;
  }
}

.padding-left-35 {
  padding-left: 35px;
}

.w-60 {
  width: 60px;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.05);
  }
}

// Utility Classes
.size-20 {
  width: 20px;
  height: 20px;
}

.me-2 {
  margin-right: 8px;
}

.pl-15 {
  padding-left: 15px;
}

// Back Button
.back-arrow {
  cursor: pointer;
  padding: 8px;
  margin-left: 24px;
  border-radius: 8px;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

h5 {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 16px;
}
</style>
